
import React, { Component, PureComponent } from 'react';
import ReactDOM from 'react-dom';
import CarTab from './CarTab';


import { connect } from 'react-redux';
import CONSTANTS from '../../constants';

const mapStateToProps = state => state;

class CarTabs extends PureComponent {

  constructor(props) {
    super(props);
    // tab value 0 means no Tab selected , so in Desktop 
    // normaly tab number 2(Serie Tab) is selected  by default 
    // but in mobile default is 0 , so no tab selected and on click on tab
    // the selected tab get shown , another click on the same tab,
    // turning the tab to 0 

    //** UPDATE : By default select the tab that has the car info by default (à la modif du rdv) */
    //** By Default : Immat */

    const ActivateTabImmat = (!!Number(window.siteConfig.ActivateTabImmat))
    const ActivateTabNumSerie = (!!Number(window.siteConfig.ActivateTabNumSerie))
    const ActivateTabModele = (!!Number(window.siteConfig.ActivateTabModele))
    this.state = {
      activeTab: (Object.values(props.store.kilo).length ? this.props.store.kilo.carStep : (window.isMobile() == 'desktop' ? (ActivateTabImmat ? '1' : ActivateTabNumSerie ? '2' : '3') : '')),
      disabledTab: false
    };

  }

  componentDidMount() {
    let len = this.props.children.length;
    let count = 0;
    this.props.children.map((child) => {
      if (!child) {
        count++;
        return;
      }
    });
    const ActivateTabImmat = (!!Number(window.siteConfig.ActivateTabImmat))
    const ActivateTabNumSerie = (!!Number(window.siteConfig.ActivateTabNumSerie))
    const ActivateTabModele = (!!Number(window.siteConfig.ActivateTabModele))
    
    if ((len - 1) == count) {
      this.setState({ disabledTab: true });
    }
    
      //Modification
      if(this.props.store.car.Registration ){
        //* Afficher Tab de l'IMMAT
        this.setState({ activeTab: '1' });
      }
      else if (this.props.store.car.SerialNumber ) {
        //* Afficher Tab du VIN
        this.setState({ activeTab: '2' });
      }
      else if(this.props.store.car.EnergyLabel){
        //* Afficher Tab du Modele
        this.setState({ activeTab: '3' });
      }
      else{
        ///* Lors de la prise du premier RDV
        if(ActivateTabImmat){
          this.setState({ activeTab: '1' });
        }
        else if(ActivateTabNumSerie){
          this.setState({ activeTab: '2' });
        }
        else if(ActivateTabModele){
          this.setState({ activeTab: '3' });
        }
        else{
          this.setState({ activeTab: '2' });
        }
        // this.setState({ activeTab: '1' });
      }
  }

  onClickTabItem = (tab) => {
    if (tab != this.state.activeTab)
      this.setState({ activeTab: tab });
    else if (window.isMobile() != 'desktop')
      this.setState({ activeTab: 0 });
  }

  render() {
    const {
      onClickTabItem,
      props: {
        children,
      },
      state: {
        activeTab,
      }
    } = this;
    return (
      <div className="car-tabs">
        {window.isMobile() == 'desktop' && <React.Fragment>
          <ol className={`tab-list ${this.state.disabledTab ? 'disabled' : ''}`}>

            {children.map((child) => {
              // this is made to skip false element , when step is disabled in BO.
              if (!child) {
                return;
              }

              const { label, order } = child.props;
              return (
                <CarTab
                  activeTab={activeTab}
                  key={order}
                  order={order}
                  label={label}
                  onClick={onClickTabItem}
                />
              );


            })}
          </ol>
          <div className="tab-content">
            {children.map((child) => {
              if (!child) {
                return;
              }
              if (child.props.order !== activeTab) return undefined;
              return child.props.children;
            })}
          </div></React.Fragment>}
        {/* if Mobile put the content inside the tab to meet the requirement of XD Design*/}
        {window.isMobile() !== 'desktop' && <React.Fragment>
          <ol className="tab-list">

            {children.map((child) => {
              // this is made to skip false element , when step is disabled in BO.
              if (!child) {
                return;
              }

              const { label, order } = child.props;

              return (
                <CarTab
                  activeTab={activeTab}
                  key={order}
                  order={order}
                  label={label}
                  onClick={onClickTabItem}
                >
                  <div className="tab-content">
                    {(child.props.order == activeTab) && children.map((child) => {
                      if (!child) {
                        return;
                      }
                      if (child.props.order !== activeTab) return undefined;
                      return child.props.children;
                    })}
                  </div>
                </CarTab>
              );

            })}
          </ol>
        </React.Fragment>}
      </div>
    );
  }
}

export default connect(mapStateToProps)(CarTabs);
